import React, { useEffect } from 'react'
import { motion, useAnimation } from 'framer-motion'
import { useInView } from 'react-intersection-observer'

export default function Contact(animation) {
	// HIDE / SHOW WINDOW
	const controls = useAnimation()
	const { ref, inView } = useInView({ threshold: 0.3 })
	const { animation: aniprops } = animation

	useEffect(() => {
		if (inView) {
			controls.start('visible')
		}
		if (!inView) {
			controls.start('hidden')
		}
	}, [controls, inView])

	return (
		<section ref={ref} className='contact section' id='contact'>
			<motion.div
				initial='hidden'
				animate={controls}
				variants={aniprops}
				className='wrapper'
			>
				<span className='section__subtitle'>Get in touch</span>
				<h2 className='section__title'>Contact Me</h2>
				<div className='contact__container container grid'>
					<div className='contact__content'>
						<h3 className='contact__title'>Talk to me!</h3>

						<div className='contact__info'>
							<div className='contact__card'>
								<i className='bx bx-mail-send contact__card-icon'></i>
								<h3 className='contact__card-title'>Email</h3>
								<span className='contact__card-data'>
									andrezzz2312@gmail.com
								</span>
								<a
									href='mailto:andrezzz2312@gmail.com'
									target='_blank'
									className='contact__button'
								>
									Text me
									<i className='bx bx-right-arrow-alt contact__button-icon'></i>
								</a>
							</div>

							<div className='contact__card'>
								<i className='bx bxl-whatsapp contact__card-icon'></i>
								<h3 className='contact__card-title'>Whatsapp</h3>
								<span className='contact__card-data'>0-995-647-033</span>
								<a
									href='https://wa.me/5930995647033?text=Hi!'
									target='_blank'
									className='contact__button'
								>
									Text me
									<i className='bx bx-right-arrow-alt contact__button-icon'></i>
								</a>
							</div>

							<div className='contact__card'>
								<i className='bx bxl-telegram contact__card-icon'></i>
								<h3 className='contact__card-title'>Telegram</h3>
								<span className='contact__card-data'>Andrez Ramirez</span>
								<a
									href='https://t.me/AndrezzzR'
									target='_blank'
									className='contact__button'
								>
									Text me
									<i className='bx bx-right-arrow-alt contact__button-icon'></i>
								</a>
							</div>
						</div>
					</div>
				</div>
			</motion.div>
		</section>
	)
}
